import { memo } from "react";

import Badge from "ui/components/Badge/Badge";

import { CronJob } from "services/api/cronjobs/types";
import { formatCronDateTime, formatDuration } from "services/api/cronjobs/transformations";

import CronJobStatusBadge from "../../../../components/CronJobStatusBadge/CronJobStatusBadge";
import CronJobExecutionStatusBadge from "../../../../components/CronJobExecutionStatusBadge/CronJobExecutionStatusBadge";
import DetailField from "../../../../components/DetailField/DetailField";

interface CronJobInfoCardProps {
  cronJob: CronJob;
}

/** Osnovni podaci o vrsti obrade — ono što planer gleda i što je zadnje napravljeno. */
const CronJobInfoCard: React.FC<CronJobInfoCardProps> = ({ cronJob }) => (
  <div className="bg-white border border-slate-200 rounded-sm p-5">
    <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-x-6 gap-y-5">
      <DetailField label="Status">
        <div className="flex items-center gap-2">
          <CronJobStatusBadge status={cronJob.status} />
          {cronJob.manualRun && <Badge text="Ručno pokretanje" variant="violet" height="small" />}
        </div>
      </DetailField>
      <DetailField label="Slug">
        <span className="font-mono text-xs">{cronJob.slug}</span>
      </DetailField>
      <DetailField label="Zadnje pokretanje">{formatCronDateTime(cronJob.lastRun)}</DetailField>
      <DetailField label="Sljedeće pokretanje">{formatCronDateTime(cronJob.nextRun)}</DetailField>

      <DetailField label="Zadnja obrada">
        {cronJob.lastExecution ? (
          <div className="flex flex-col gap-1">
            <div className="flex items-center gap-2">
              <CronJobExecutionStatusBadge status={cronJob.lastExecution.status} />
              <span className="text-xs text-slate-400">
                {formatDuration(cronJob.lastExecution.durationSeconds)}
              </span>
            </div>
            <span className="text-xs text-slate-500">
              {formatCronDateTime(cronJob.lastExecution.started)}
            </span>
          </div>
        ) : (
          <span className="text-slate-400">—</span>
        )}
      </DetailField>
      <DetailField label="Broj obrada">{cronJob.executionCount}</DetailField>
      <DetailField label="Opis" wide>
        <span className="text-slate-600">{cronJob.description || "—"}</span>
      </DetailField>

      {cronJob.metadata && (
        <DetailField label="Metapodaci" wide>
          <pre className="font-mono text-xs bg-slate-50 border border-slate-200 rounded p-3 whitespace-pre-wrap break-all">
            {cronJob.metadata}
          </pre>
        </DetailField>
      )}
    </div>
  </div>
);

export default memo(CronJobInfoCard);
